import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseConfig } from '../../common/config/config.adapter';


@Component({
  selector: 'lepi-menu-option',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './menu-option.component.html',
  styleUrls: ['./menu-option.component.css'],
})
export class MenuOption extends BaseConfig {
  icon = input<string>();
  active = input<boolean>(false);
  focus = input<boolean>(false);
}
